<template>
    <div class="container is-fluid" id="flights">
        <button class="advanced-searh-button button is-small is-light"
                :class="{'is-info':advancedSearch , 'is-danger' : !advancedSearch}"
                @click="advancedSearch =! advancedSearch">Advanced Search
        </button>
        <div class="search-menu columns">
            <div v-if="!advancedSearch" class="normal-search  column is-9">
                <header class="level">
                    <div class="level-left">
                        <div class="field">
                            <div class="control">
                                <input class="box-info-search input" type="text" v-model="searchText"
                                       placeholder="Filter in table">
                            </div>
                        </div>
                    </div>
                    <div>
                        <label class="heading is-size-4">FLIGHTS</label>
                    </div>
                    <div class="level-right">
                        <div class="field has-addons">
<!--                            <datepicker v-model="searchDate" :config="{wrap:true}"></datepicker>-->

                            <datepicker2 class="bg-red" input-class="input-class"  @closed="TrygetFligths" v-model="searchDatePickerFormat"
                                         :format="customFormatter"
                                         :disabledDates="disabledDays"></datepicker2>

                            <div class="control">
                                <a class="button  is-success is-fullwidth" :disabled="isLoading"
                                   @click="TrygetFligths">
                                        <span class="icon is-small">
                                                <font-awesome-icon :icon="isLoading ? 'sync-alt' : 'sync-alt'"
                                                                   :spin="isLoading"/>
                                        </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
            <div v-else class="advanced-searh column is-9">

                <div class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <div class="field">
                                <div class="control">
                                    <input class="input" v-model="advancedSearchForm.AcReg" placeholder="Registration">
                                </div>
                            </div>
                        </div>
                        <div class="level-item">

                            <div class="field">
                                <div class="control">
                                    <input class="input" v-model="advancedSearchForm.CallSign" placeholder="Call Sign">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="level-right">
                        <div class="level-item">
                            <div class="control">
                                <a class="button  is-success is-fullwidth" :disabled="isLoading"
                                   @click="TryAdvancedSearch">
                                        <span class="icon is-small">
                                                <font-awesome-icon :icon="isLoading ? 'sync-alt' : 'search'" :spin = "isLoading"/>
                                        </span>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="menu-flight-details  column is-3 has-text-centered">
                <label class="heading is-centered is-size-4">
                    <font-awesome-icon icon="arrow-circle-right" color="" size="lg"></font-awesome-icon>
                    Flight Details
                </label>
                <div class="columns"  style="justify-content: right;">
                    <div class="column has-text-right">
                        <download-excel :data="excelFlightList" style="cursor: pointer">
                            <!--  <p style="margin: 10px;" class="title is-size-5">Excel Download</p>  -->
                            <button class="button is-link is-success is-small">Excel Download</button>
                        </download-excel>
                    </div>
                    <div class="column has-text-right">
                        <div class="tooltip"><font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                            <div class="tooltiptext">
                                <ul style="list-style: disc outside">
                                    <li style="margin-left: 20px">
                                        <p style="margin-bottom: 10px">On a daily basis, you can view the flight summary list</p>
                                    </li>
                                    <li style="margin-left: 20px">
                                        <p style="margin-bottom: 10px">You can see the ipad app preview if there is information signed by the pilot for the flight.</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flight-main columns">
            <div v-if="flights.length>0 && !isLoading"
                 class="flight-table column is-9 ">
                <table class="table is-narrow is-striped is-bordered">
                    <thead>
                    <tr>
                        <!--                        <th>FP</th>-->
                        <!--                        <th scope="col">Signed</th>-->
                        <!--                        <th scope="col">Briefing</th>-->
                        <!--                        <th scope="col">Report</th>-->
                        <th scope="col">Flight Date</th>
                        <th scope="col">Flight No</th>
                        <th scope="col">Departure</th>
                        <th scope="col">Aircraft Registration</th>
                        <th scope="col">Arrival</th>
                        <th scope="col">Details</th>
                        <th scope="col">Ipad Preview</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="flight in searchFlights" :key="flight.id"
                        :class="{'table-row-transition':selectedFlightRow == flight.fKeyForZip}">

<!--                        <td>-->
<!--                            <font-awesome-icon icon="file-pdf" color="red" size="lg" cursor="pointer" @click="fpClick( flight.fKeyForZip)"/>-->
<!--                        </td>-->
<!--                        <td v-if="flight.weather==true">-->
<!--                            <font-awesome-icon icon="check-circle" color="blue" size="lg"/>-->
<!--                        </td>-->
<!--                        <td v-else>-->
<!--                            <font-awesome-icon icon="check-circle" color="red" size="lg"/>-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <font-awesome-icon icon="file" color="" size="lg" cursor="pointer" @click="briefingClick( flight.fKeyForZip)"/>-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <font-awesome-icon icon="file-alt" color="" size="lg" cursor="pointer" @click="showFlightReport( flight.fKeyForZip)"/>-->
<!--                        </td>-->

                        <td>{{flight.tarih | shortFormatDateNumeric}}</td>
                        <td>{{flight.carrier}}{{flight.fno}}</td>
                        <td>{{flight.adep}}</td>
                        <td>{{flight.acreg}}</td>
                        <td>{{flight.aarr}}</td>
                        <td v-if="selectedFlightRow==flight.fKeyForZip" style="text-align: center">
                            <font-awesome-icon icon="arrow-circle-right" color="green" size="lg" cursor="pointer"/>
                        </td>
                        <td v-else style="text-align: center">
                            <font-awesome-icon icon="arrow-circle-right" color="" size="lg" cursor="pointer" @click="tryGetFlight(flight)"/>
                        </td>
                        <td v-if="flight.generaL_STAT!=0" style="text-align: center">
                            <font-awesome-icon icon="tablet-alt" color="blue" size="lg" cursor="pointer" @click="TryGetIpadPreview(flight.fKeyForZip,flight)"/>
                        </td>
                        <td v-else style="text-align: center">
                            <font-awesome-icon icon="tablet-alt" color="" size="lg" cursor="pointer"/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="notification flight-table column is-9">

                <div v-if="isLoading">
                    <loading-button/>
                </div>

                <span v-else>
                    <label class="heading">No Flights yet...</label>
                </span>

            </div>

            <div class="flight-detail column is-3">
                <div v-if="flight.length == null">
                    <div class="card-content">
                        <ul class="issue-details--meta">
                            <li style="border: 1px solid gainsboro;padding:10px">
                                <p class="flight-details--meta-title">FKey#</p>
                                <p class="flight-details--meta-desc">{{flight.fKeyForZip}}</p>
                            </li>
                        </ul>
                        <div class="columns">
                            <div class="column is-6">
                                <ul class="issue-details--meta">
                                    <li>
                                        <p class="flight-details--meta-title">Flight No
                                        <p>
                                        <p class="flight-details--meta-desc">{{flight.fno}}</p>
                                    </li>

                                    <li>
                                        <p class="flight-details--meta-title">Departure</p>
                                        <p class="flight-details--meta-desc">{{flight.adep}}</p>
                                    </li>

<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Estimated Block Fuel Kg</p>-->
<!--                                        <p class="flight-details&#45;&#45;meta-desc">{{BlockFuelEstimatedWeightKg}}</p>-->
<!--                                    </li>-->

<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Estimated Block Fuel Duration Min</p>-->
<!--                                        <p class="flight-details&#45;&#45;meta-desc">{{BlockFuelDurationMin}}</p>-->
<!--                                    </li>-->

                                    <li>
                                        <p class="flight-details--meta-title">Schedule Time Departure
                                        <p>
                                        <p class="flight-details--meta-desc">{{flight.std| formatDateNumericWithHour}}</p>
                                    </li>

<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Actual Block Fuelincl Taxi Kg-->
<!--                                        <p>-->
<!--                                        <p class="flight-details&#45;&#45;meta-desc">{{flight.actualBlockFuelinclTaxiKg}}</p>-->
<!--                                    </li>-->

<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Planned Fuel Up lift Liter-->
<!--                                        <p>-->
<!--                                        <p class="flight-details&#45;&#45;meta-desc">{{flight.plannedFuelUpliftLiter}}</p>-->
<!--                                    </li>-->

<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Density-->
<!--                                        <p>-->
<!--                                        <p class="flight-details&#45;&#45;meta-desc">{{flight.density}}</p>-->
<!--                                    </li>-->

<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Landing Fuel From Prev Flight Kg-->
<!--                                        <p>-->
<!--                                        <p class="flight-details&#45;&#45;meta-desc">{{flight.landingFuelFromPrevFlightKg}}</p>-->
<!--                                    </li>-->

                                </ul>

                            </div>
                            <div class="column is-6">
                                <ul class="issue-details--meta">

                                    <li>
                                        <p class="flight-details--meta-title">Tail</p>
                                        <p class="flight-details--meta-desc">{{flight.acreg}}</p>
                                    </li>

                                    <li>
                                        <p class="flight-details--meta-title">Arrival</p>
                                        <p class="flight-details--meta-desc">{{flight.aarr}}</p>
                                    </li>

<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Actual Block Fuel KG</p>-->

<!--                                        <p class="flight-details&#45;&#45;meta-desc">9999</p>-->
<!--                                    </li>-->

<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Actual Block Fuel Duration Min</p>-->

<!--                                        <p class="flight-details&#45;&#45;meta-desc">9999</p>-->
<!--                                    </li>-->

                                    <li>
                                         <p class="flight-details--meta-title">Schedule Time Arrival</p>
                                         <p class="flight-details--meta-desc"> {{flight.sta|formatDateNumericWithHour}}</p>
                                    </li>

<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Planned Block Fuelinc TaxiKg-->
<!--                                        <p>-->
<!--                                        <p class="flight-details&#45;&#45;meta-desc">{{flight.plannedBlockFuelinclTaxiKg}}</p>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Actual Fuel Uplift Liter-->
<!--                                        <p>-->
<!--                                        <p class="flight-details&#45;&#45;meta-desc">{{flight.actualFuelUpliftLiter}}</p>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Fuel Used Diff-->
<!--                                        <p>-->
<!--                                        <p class="flight-details&#45;&#45;meta-desc">{{flight.fuelUsedDiff}}</p>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <p class="flight-details&#45;&#45;meta-title">Delta Fuel Up lift Liter-->
<!--                                        <p>-->
<!--                                        <p class="flight-details&#45;&#45;meta-desc">{{flight.deltaFuelUpliftLiter}}</p>-->
<!--                                    </li>-->

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <article v-else class="message is-white">
                    <div class="message-header">
                        <p class="heading">{{detailMessage.fKeyForZip}}</p>
                    </div>
                    <div class="message-body" :style="{'background-color':detailMessage.color}">
                        <label class="heading has-text-weight-bold">{{detailMessage.text}}</label>
                    </div>
                </article>
            </div>
        </div>

        <ShowAttachmentModal
                :isActiveAttachmentModal='isActiveAttachmentModal'
                :activeUrl="activeUrl"
                @closeAttachmentModal="closeAttachmentModal"
        />

    </div>

</template>

<script>

    import {createNamespacedHelpers} from "vuex";
    // import Datepicker from 'vue-bulma-datepicker';
    import ShowAttachmentModal from "../../components/ui/ShowAttachmentModal";
    import {loadingMixin} from "../../utils/mixins";
    import LoadingButton from "../../components/ui/LoadingButton";
    import {createUrl} from "../../http";
    import * as moment from "moment";
    import Datepicker2 from 'vuejs-datepicker';

    var currentDateWithFormat = new Date().toISOString().slice(0, 10);

    const {mapState, mapMutations, mapActions} = createNamespacedHelpers('flights');
    export default {

        name: 'flights',

        mixins: [loadingMixin],

        data: function () {
            return {
                searchText: '',
                excelFlightList: [],
                searchDate: currentDateWithFormat,
                searchDatePickerFormat : null,
                disabledDays : null,
                advancedSearch: false,
                isActiveAttachmentModal: false,
                activeUrl: '',
                reportModalUrl: createUrl("/Attachment/GetReport/"), // 'https://localhost:44333/api/Attachment/GetReport/',  // /Attachment/GetReport   bu kullanılmamaktadır kontrol et
                advancedSearchForm: {
                    AcReg: "",
                    Tarih: null,
                    CallSign: "",
                }
            }
        },

        props: {
            loading: {type: Boolean}
        },

        components: {
            // Datepicker,
            ShowAttachmentModal,
            LoadingButton,
            Datepicker2
        },

        async created() {

            this.searchDatePickerFormat = this.searchDate;
            await this.TrygetFligths();

            var utcDate = new Date()
            utcDate.setUTCHours(utcDate.getHours());
            var calcAddday = utcDate;
            calcAddday.setDate(calcAddday.getDate()+1);
            this.disabledDays = { from: calcAddday };

        },

        methods: {
            ...mapActions([
                "getFlights",
                "getFlight",
                "getAdvancedSearch",
                "GetJRjsonData","BlockFuelDurationMin","BlockFuelEstimatedWeightKg",
            ]),

            ...mapMutations([
                "set_flight",
                "set_selected_flight",
            ]),
            customFormatter
            (date) {
                return moment(date).format('YYYY-MM-DD');
            },

            fpClick(value) {
                this.$router.push({name: 'FlightPlaning', params: {id: value}});
            },
                TryGetIpadPreview(fKeyForZip, Flight) {
                console.log(fKeyForZip, Flight)
                this.$router.push({name: 'IpadMain', params: {id: fKeyForZip, kfnl:Flight.fKeyForNetline, legno:Flight.leG_NO, flight: Flight}});
               // // // // this.$router.push({name: 'IpadMain', params: {id: this.FKeyForZip,kfnl:this.FkeyForNetline,  flight: this.flight}});
            },

            briefingClick(value) {
                this.selectedFlightRow = value;

            },

            reportClick(value) {
                this.selectedFlightRow = value;

            },

            async tryGetFlight(value) {

                try {

                    await this.getFlight(value);

                    //await this.GetJRjsonData({KFZ:value.fKeyForZip,STD:value.std,JLVT:value.jlvt});

                }catch (e) {

                    //this.$notify({title: "Warning", text: e.response.data, type: "warn"})

                }

                // try {
                //     this.$store.commit('flights/set_selected_flight', value)
                //     await this.getFlight(value);
                // } catch (e) {
                //     this.$notify({title: "Warning", text: e.response.data, type: "warn"})
                //     const a = {FKey1: value, text: e.response.data, color: '#ffff00ad'}
                //     this.$store.commit('flights/set_detail_message', a)
                // }

            },

            async TrygetFligths() {

                this.SearchDate  = moment(this.searchDatePickerFormat).format('YYYY-MM-DD');

               this.showLoading();
                try {
                    await this.getFlights(this.SearchDate);
                } catch (e) {
                    //this.$notify({title: "Error", text:"Error on TrygetFligths function e: " +e.message, type: "error"});
                } finally {
                   this.hideLoading();
                }
            },

            async TryAdvancedSearch() {
               this.showLoading();
                try {
                    this.advancedSearchForm.AcReg = this.advancedSearchForm.AcReg.toUpperCase();
                    this.advancedSearchForm.CallSign = this.advancedSearchForm.CallSign.toUpperCase();
                    await this.getAdvancedSearch(this.advancedSearchForm);
                } catch (e) {
                    //this.$notify({title: "Error", text:"Error on getAdvancedSearch function e: " + e.message, type: "error"});
                } finally {
                   this.hideLoading();
                }
            },

            closeAttachmentModal() {
                this.isActiveAttachmentModal = false;
            },

            showFlightReport(value) {
                this.isActiveAttachmentModal = true;
                this.activeUrl = this.reportModalUrl + '?fKeyForZip=' + value;
            },

        },
        computed: {
            ...mapState([
                "flights",
                "flight",
                "selectedFlightRow",
                "detailMessage","JsonFuelDetails","JRjson"
            ]),

            searchFlights: function () {
                //let returnlist = this.flights.filter((post) => {
                let returnlist = this.flights.filter((post) =>
                            post.fKeyForZip.toUpperCase().match(this.searchText.toUpperCase().replace("-", "_"))
                           || post.adep.toUpperCase().match(this.searchText.toUpperCase())
                           || post.aarr.match(this.searchText)
                )

                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.excelFlightList = returnlist;
                return returnlist;
            },

            excelArray: function()
            {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.excelBody = this.excelFlightList.map(item => ({
                    "aC_OWNER": item.aC_OWNER,
                    "aL_LVC": item.aL_LVC,
                    "aL_SignedBy": item.aL_SignedBy,
                    "aarr": item.aarr,
                    "acreg": item.acreg,
                    "adep": item.adep,
                    "ata": item.ata,
                    "atd": item.atd,
                    "attachmentCount": item.attachmentCount,
                    "btO_LVC": item.btO_LVC,
                    "btO_SignedBy": item.btO_SignedBy,
                    "cP1": item.cP1,
                    "cP2": item.cP2,
                    "cP3": item.cP3,
                    "cabinList": item.cabinList,
                    "callsign": item.callsign,
                    "carrier": item.carrier,
                    "carrierfno": item.carrierfno,
                    "devicE_UUID1": item.devicE_UUID1,
                    "devicE_UUID2": item.devicE_UUID2,
                    "devicE_UUID3": item.devicE_UUID3,
                    "diS_TYPE": item.diS_TYPE,
                    "diV_ARR": item.diV_ARR,
                    "errorCOunt": item.errorCOunt,
                    "fKeyForZip": item.fKeyForZip,
                    "flightArchiveStat": item.flightArchiveStat,
                    "flightRelease": item.flightRelease,
                    "flightReportStat": item.flightReportStat,
                    "fnO_CORRECTED": item.fnO_CORRECTED,
                    "fno": item.fno,
                    "generaL_STAT": item.generaL_STAT,
                    "iS_AIRCRAFT_USED": item.iS_AIRCRAFT_USED,
                    "iS_DELETED": item.iS_DELETED,
                    "jlvt": item.jlvt,
                    "lasT_IPADDEVICE_UID": item.lasT_IPADDEVICE_UID,
                    "lasT_LVC": item.lasT_LVC,
                    "lastPlanIdSucceed": item.lastPlanIdSucceed,
                    "leG_NO": item.leG_NO,
                    "notE_CNT": item.notE_CNT,
                    "notamWeb": item.notamWeb,
                    "progress": item.progress,
                    "raimPrediction": item.raimPrediction,
                    "sarr": item.sarr,
                    "sdep": item.sdep,
                    "sortOrder": item.sortOrder,
                    "sta": item.sta,
                    "staT_MIN1": item.staT_MIN1,
                    "staT_MIN2": item.staT_MIN2,
                    "staT_MIN3": item.staT_MIN3,
                    "std": item.std,
                    "suffix": item.suffix,
                    "tarih": item.tarih,
                    "tlC1": item.tlC1,
                    "tlC2": item.tlC2,
                    "tlC3": item.tlC3,
                    "warningCOunt": item.warningCOunt,
                    "weather": item.weather,
                    "weatherWeb": item.weatherWeb,
                    "wlvt": item.wlvt,
                }));

                return this.excelBody;
            }


        }
    };
</script>

<style lang="scss">
    input.input-class{
        height: 40px;
        border-radius: 5px;
        border-bottom-right-radius: unset;
        border-top-right-radius: unset;
        border-color: #dadada;
        font-size: medium;
    }
</style>

<style scoped>
    .table {
        width: 100%;
    }

    .search-menu {
        box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
    }

    .advanced-searh {
        display: block;
    }

    .advanced-searh-button {
        margin-bottom: 20px;
        margin-left: -12px;
    }

    .menu-flight {
        background-color: #f8f9fa;
        height: 60px;
        padding: 10px;
    }

    .flight-main {
        background-color: #fff;
        box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
        color: #4a4a4a;
        margin-top: 15px;
        padding: 1.25rem;

    }

    .flight-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 20px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .flight-table td {
        border: 0px;
    }

    .flight-table {
        overflow-y: scroll;
        height: 630px;
    }

    .flight-table th {
        top: -12px;
        positiairports-tableon: sticky;
        background-color: white;
        z-index: 2;
    }

    .flight-detail {
        border: solid 1px #e4e4e4;
        /*box-shadow: 2px 2px 6px #000;*/
        box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.27);
        max-height: 800px;
        background-color: white;
    }

    .flight-details--meta-title {
        font-size: 11px;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: #9e9e9e;
        font-weight: 700;
        margin-top: 10px;
    }

    .flight-details--meta-desc {
        font-size: 18px;
        font-weight: 300;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar {
        height: 2px;
        width: 8px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #6a85a7;
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border:3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -366px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }

</style>
